import { HashRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import moment from 'moment';
import { AppProvider } from './hooks';
import Routes from './routes';

import GlobalStyles from './styles/global';

moment.locale('pt-br');

function App() {
  return (
    <Router>
      <AppProvider>
        <GlobalStyles />
        <Routes />
        <ToastContainer
          closeOnClick
          autoClose={false}
          closeButton
          position="top-right"
          theme="colored"
        />
      </AppProvider>
    </Router>
  );
}

export default App;
